import { getStateSetter } from './utils';

export const holderInitialState = {
  user: {
    id: null,
    typeOfInvestor: null,
    email: null,
    identityAddress: null,
    identityId: null,
    investor: null,
    wallet: null,
    individual: null,
    institutional: null,
    createdAt: null,
    updatedAt: null,
  },
  tokens: null,
  selectedToken: null,
  balances: [],
  messages: [],
  pendingRequests: [],
  redemption: null,
  dfnsWalletId: null,
};

const setState = getStateSetter('holder');

export const holderActions = () => ({
  setTokens: (state, value) => setState(state, { tokens: value }),
  setSelectedToken: (state, value) => {
    sessionStorage.setItem('selectedToken', JSON.stringify(value));
    return setState(state, { selectedToken: value });
  },
  setUser: (state, value) => setState(state, { user: value }),
  resetUser: (state) => setState(state, holderInitialState),
  setMessages: (state, value) => setState(state, { messages: value }),
  setPendingRequests: (state, value) => setState(state, { pendingRequests: value }),
  setBalances: (state, value) => setState(state, { balances: value }),
  setRedemption: (state, value) => setState(state, { redemption: value }),
  setDfnsWalletId: (state, value) => setState(state, { dfnsWalletId: value }),
});
